import type { MutableRefObject, ReactNode } from "react";
import type { ImageShapeEnum } from "../image";

export const enum TickerItemTypeEnum {
  Image = "image",
}

export const enum TickerItemImageFitEnum {
  Fit = "fit",
  Fill = "fill",
}

export const enum TickerAnimDirectionEnum {
  Right = "right",
  Up = "up",
  Down = "down",
  Left = "left",
}
export const enum TickerAnimSpeedEnum {
  Fast = "fast",
  Medium = "medium",
  Slow = "slow",
}

export interface ITickerItem {
  id: string;
  type: TickerItemTypeEnum;
  src: string;

  classification?: string;
  variable?: string;
  alt?: string;
  overlay?: boolean;
  overlayOpacity?: number;
  overlayColor?: string;

  // Link
  linkType?: string;
  linkUrl?: string;
  openInPopup?: boolean;
  linkAnalyticsEvent?: string;
  anchorTrigger?: string;
}

export interface ITickerSpecificSettings {
  shape: ImageShapeEnum;
  tickerItems: ITickerItem[];
  tickerItemImageFit: TickerItemImageFitEnum;
  tickerItemsSpacing: number;
  tickerItemPadding: number;

  tickerAnimDirection: TickerAnimDirectionEnum;
  tickerAnimSpeed: TickerAnimSpeedEnum;
}

export interface ITickerSettings extends ITickerSpecificSettings {
  name: string;

  width: string;
  height: number;
  shadow: string;

  horizontalAlignment: string;

  backgroundColor: string;

  borderColor: string;
  borderWidth: number;

  round: string;
}

export interface ITickerEditorData {
  width: string;
  height: number;
  containerRef: MutableRefObject<HTMLDivElement | null>;
  openEditDialog: () => Promise<void>;

  emptySlot: ReactNode;
  resizeSlot: ReactNode;
  variablesLabelSlot: ReactNode;
}
